__webpack_require__.p = "/wp-content/plugins/gif-register-by-owl360/dist/";